import React from "react";
import logo from "../../assets/BASEET-no-bg.png";

const Logo = () => {
  return (
    <div className="logo-fixed">
      <img src={logo} alt="Logo" />
    </div>
  );
};

export default Logo;
